import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {MatSnackBar} from '@angular/material';


import {Audit} from '../../audit.model';
import { AuditService } from '../../audit.service';

@Component({
  selector: 'iaud-audit-edit-dialog',
  templateUrl: './audit-edit-dialog.component.html',
  styleUrls: ['./audit-edit-dialog.component.scss'],
})
export class AuditEditDialogComponent {
  audit: Audit;
  isFormValid: boolean;

  constructor(
    private auditService: AuditService,
    public dialogRef: MatDialogRef<AuditEditDialogComponent>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.audit = {...data.audit};
  }

  update(): void {
    this.auditService.updateAudit(this.audit)
    .subscribe(response => {
      this.dialogRef.close({audit: response, success: true});
    }, error => {
      this.snackBar.open(`Error updating Audit Report: ${error.error.error.message}`, 'Ok', {
        duration: 4000,
      });
    });

  }

  toggleFormValidity(valid: boolean): void {
    this.isFormValid = valid;
  }
}
